export default __webpack_public_path__ + "static/media/svg-symbols.76b28b41.svg";